/* esm.sh - qrcode@1.5.4 */
export * from "/*qrcode@1.5.4/esnext/qrcode.mjs";
export { default } from "/*qrcode@1.5.4/esnext/qrcode.mjs";
